import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=4717b4ab&scoped=true&"
import script from "./PortfolioItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioItem.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=4717b4ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4717b4ab",
  null
  
)

export default component.exports